<template>
  <div class="pr-1 py-4 sm:py-3 pl-10 sm:pl-6 flex flex-col w-full h-full">
    <h1 class="w-full mb-3 text-sm text-white font-bold">{{ customFilter.current_wpp.wpp_name }}</h1>
    <div class="flex flex-row gap-1 w-full mb-3">
      <input
        v-model="kapalSearch"
        class="flex-1 px-3 py-3 h-8 form-input rounded-md text-xs"
        type="text"
        placeholder="cari kapal ...">
    </div>
    <div class="Scroll pr-3 w-full h-full overflow-hidden">
      <div class="flex flex-row gap-1 justify-end mb-3">
        <button
          @click="download()"
          class="bg-green-500 px-2 py-2 rounded-md text-xs text-white"
          type="button">Export List Kapal</button>
      </div>
      <table class="table-auto w-full mb-3">
        <colgroup>
          <!-- <col style="width: 10%;" /> -->
          <col style="width: 65%;" />
          <col style="width: 35%;" />
        </colgroup>
        <thead>
          <tr>
            <th class="font-normal h-10 border border-gray-400 border-r-0 px-3 py-3 text-xs text-white text-left font-bold">KAPAL</th>
            <th class="font-normal h-10 border border-gray-400 border-l-0 px-3 py-3 text-xs text-white text-right font-bold">TRANSMITTER</th>
          </tr>
        </thead>
        <tbody class="border border-gray-400">
          <tr
            v-for="(kapal, index) in filteredListKapal()"
            :key="index"
            @click="selectKapal(kapal)"
            class="hover:bg-gray-300 cursor-pointer">
            <td class="text-xs text-left px-3 py-1 text-white">{{ kapal.properties.nama_kapal }}</td>
            <td class="text-xs text-right px-3 py-1 text-white">{{ kapal.properties.transmitter }}</td>
          </tr>
        </tbody>
      </table>
      <Pagination
        class="justify-end items-end"
        :offset="offset"
        :limit="limit"
        :total="total"
        :handler="changePage" />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import Pagination from './Pagination.vue'

export default {
  name: 'TableListKapalCurrentWPP',
  data: () => ({
    offset: 0,
    limit: 50,
    total: 0,
    kapalSearch: null
  }),
  computed: {
    ...mapGetters([
      'auth',
      'listKapal',
      'activeFilter',
      'optionalFilter',
      'customFilter'
    ])
  },
  components: {
    Pagination
  },
  methods: {
    ...mapActions(['toZoom']),
    ...mapMutations([
      'setActiveSubMenu',
      'setKapal'
    ]),
    filteredListKapal: function () {
      const listKapal = []
      const key = this.kapalSearch ? this.kapalSearch.toLowerCase() : null
      let total = 0

      for (var i = this.offset; i < this.listKapal.total; i++) {
        if (this.listKapal.features[i]) {
          if (this.listKapal.features[i].properties.current_wpp !== this.customFilter.current_wpp.wpp_name) {
            continue
          }

          if (key) {
            if (this.listKapal.features[i].properties.nama_kapal
                .toLowerCase()
                .indexOf(key) > -1 ||
                this.listKapal.features[i].properties.nama_perusahaan
                .toLowerCase()
                .indexOf(key) > -1 ||
                this.listKapal.features[i].properties.transmitter
                .toString()
                .indexOf(key) > -1) {
              if (listKapal.length < this.limit) {
                listKapal.push(this.listKapal.features[i])
              } else {
                total += 1
              }
            }
          } else {
            listKapal.push(this.listKapal.features[i])

            total += 1
          }
        } else {
          break
        }
      }

      if (key) {
        this.total = total
      } else {
        this.total = this.offset + total
      }

      return listKapal
    },
    download: async function () {
      let exportUrl = `${window.config.BASEURL}/libs/report/list-kapal.html?`

      exportUrl += `token=${this.auth.token}`
      exportUrl += `&filter=${this.activeFilter.id}`
      exportUrl += `&nama_perusahaan=${this.optionalFilter.nama_perusahaan}`
      exportUrl += `&jenis_alat_tangkap=${this.optionalFilter.jenis_alat_tangkap}`
      exportUrl += `&current_wpp=${this.customFilter.current_wpp.wpp_id}`

      window.open(
        exportUrl,
        { target: '__blank' }
      )
    },
    changePage: async function (page) {
      this.offset = page.offset
    },
    selectKapal: function (kapal) {
      this.setKapal(kapal.properties)
      this.toZoom({
        zoom: 10,
        view: [
            kapal.properties.lat,
            kapal.properties.lon
          ]
      })
    }
  },
  watch: {
    kapalSearch: function () {
      this.offset = 0
    }
  }
}
</script>
